<template>
    <div>
        <el-form :model="deprInfo" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <table class="simple-tbl" style="width: 100%;">
                <thead class="head">
                <tr class="row">
                    <th style="width: 50px; text-align: center;">选择</th>
                    <th style="width: 150px;"><span>名称</span></th>
                    <th style="text-align: right"><span>当前值</span></th>
                    <th style="width: 140px;"><span>调整值</span></th>
                    <th><span>扩展</span></th>
                    <th style="text-align: right">
                        <span class="swb-btn swb-btn-link" @click="takeTestResult">试算结果</span>
                    </th>
                    <th style="width: 180px;"><span>禁用原因</span></th>
                </tr>
                </thead>
                <tbody class="body">
                    <tr class="row">
                        <td style="width: 50px;text-align: center;">
                            <el-checkbox :disabled="aspectInfoMap['ntxPrice'] != null || deprInfo.ntxPriceMutex" v-model="deprInfo.ntxPriceChecked" @change="comnCheckChange('ntxPrice')"></el-checkbox>
                        </td>
                        <td><span>未税价(元)</span></td>
                        <td style="text-align: right"><span v-if="deprInfo.ntxPrice != null">{{deprInfo.ntxPrice.toFixed(2)}}</span></td>
                        <td>
                            <el-input class="text-right" v-if="deprInfo.ntxPriceChecked" :disabled="aspectInfoMap['ntxPrice'] != null || deprInfo.ntxPriceMutex" type="text" v-model="deprInfo.ntxPrice2" @change="orgWorthChange(deprInfo)"></el-input>
                        </td>
                        <td><span></span></td>
                        <td style="text-align: right">
                            <span v-if="deprInfo.ntxPrice3 != null" :class="deprInfo.ntxPrice2 != deprInfo.ntxPrice3? 'font-blue': ''">{{deprInfo.ntxPrice3}}</span>
                        </td>
                        <td style="width: 180px;">
                            <span v-if="aspectInfoMap['ntxPrice'] != null" class="font-gold">{{aspectInfoMap['ntxPrice']}}</span>
                        </td>
                    </tr>
                    <tr class="row">
                        <td style="width: 50px;text-align: center;">
                            <el-checkbox :disabled="aspectInfoMap['taxPrice'] != null || deprInfo.taxPriceMutex" v-model="deprInfo.taxPriceChecked" @change="comnCheckChange('taxPrice')"></el-checkbox>
                        </td>
                        <td><span>进项税额(元)</span></td>
                        <td style="text-align: right"><span v-if="deprInfo.taxPrice != null">{{deprInfo.taxPrice.toFixed(2)}}</span></td>
                        <td>
                            <el-input class="text-right" v-if="deprInfo.taxPriceChecked" :disabled="aspectInfoMap['taxPrice'] != null || deprInfo.taxPriceMutex" type="text" v-model="deprInfo.taxPrice2" @change="orgWorthChange(deprInfo)"></el-input>
                        </td>
                        <td><span></span></td>
                        <td style="text-align: right">
                            <span v-if="deprInfo.taxPrice3 != null" :class="deprInfo.taxPrice2 != deprInfo.taxPrice3? 'font-blue': ''">{{deprInfo.taxPrice3}}</span>
                        </td>
                        <td style="width: 180px;">
                            <span v-if="aspectInfoMap['taxPrice'] != null" class="font-gold">{{aspectInfoMap['taxPrice']}}</span>
                            <!--<el-tooltip class="item fr" effect="dark" placement="top" :open-delay="200">-->
                            <!--<span slot="content" style="white-space: pre-wrap" v-html="taxPriceText"></span>-->
                            <!--<span class="col-title-tooltip-wrapper"><i class="el-icon-question col-title-tooltip"></i></span>-->
                            <!--</el-tooltip>-->
                        </td>
                    </tr>
                    <tr class="row">
                        <td style="width: 50px;text-align: center;">
                            <el-checkbox :disabled="aspectInfoMap['taxRate'] != null || deprInfo.taxRateMutex" v-model="deprInfo.taxRateChecked" @change="comnCheckChange('taxRate')"></el-checkbox>
                        </td>
                        <td><span>进项税率(%)</span></td>
                        <td style="text-align: right"><span v-if="deprInfo.taxRate != null">{{deprInfo.taxRate.toFixed(2)}}</span></td>
                        <td>
                            <el-select v-if="deprInfo.taxRateChecked" v-model="deprInfo.taxRate2" :disabled="aspectInfoMap['taxRate'] != null || deprInfo.taxRateMutex" placeholder="请选择税率">
                                <el-option v-for="item in fiscalTaxMarkList" :key="item.rate" :label="item.rate" :value="item.rate"></el-option>
                            </el-select>
                        </td>
                        <td><span></span></td>
                        <td style="text-align: right">
                            <span v-if="deprInfo.taxRate3 != null" :class="deprInfo.taxRate2 != deprInfo.taxRate3? 'font-blue': ''">{{deprInfo.taxRate3}}</span>
                        </td>
                        <td style="width: 180px;">
                            <span v-if="aspectInfoMap['taxRate'] != null" class="font-gold">{{aspectInfoMap['taxRate']}}</span>
                            <!--<el-tooltip class="item fr" effect="dark" placement="top" :open-delay="200">-->
                            <!--<span slot="content" style="white-space: pre-wrap" v-html="taxRateText"></span>-->
                            <!--<span class="col-title-tooltip-wrapper"><i class="el-icon-question col-title-tooltip"></i></span>-->
                            <!--</el-tooltip>-->
                        </td>
                    </tr>
                    <tr class="row">
                        <td style="width: 50px;text-align: center;">
                            <i class="el-icon-info" style="color: #0c64eb"></i>
                            <!--<el-checkbox :disabled="aspectInfoMap['orgWorth'] != null || deprInfo.orgWorthMutex" v-model="deprInfo.orgWorthChecked" @change="comnCheckChange('orgWorth')"></el-checkbox>-->
                        </td>
                        <td><span>抵扣进项税</span></td>
                        <td style="text-align: right"><span>{{deprInfo.taxOffset? '是': '否'}}</span></td>
                        <td style="text-align: left" colspan="4">
                            <span style="color: #999">资产验收时，如果选择了抵扣进项税，则进项税额不计入资产原值</span>
                        </td>
                    </tr>
                    <tr class="row">
                        <td style="width: 50px;text-align: center;">
                            <i class="el-icon-info" style="color: #0c64eb"></i>
                            <!--<el-checkbox :disabled="aspectInfoMap['orgWorth'] != null || deprInfo.orgWorthMutex" v-model="deprInfo.orgWorthChecked" @change="comnCheckChange('orgWorth')"></el-checkbox>-->
                        </td>
                        <td><span>其他费价(元)</span></td>
                        <td style="text-align: right"><span v-if="deprInfo.xtraFee != null">{{deprInfo.xtraFee.toFixed(2)}}</span></td>
                        <td style="text-align: left" colspan="4">
                            <span style="color: #999">包含：物流费单价、安装费、组装费等</span>
                        </td>
                    </tr>
                    <tr class="row">
                        <td style="width: 50px;text-align: center;">
                            <el-checkbox :disabled="aspectInfoMap['orgWorth'] != null || deprInfo.orgWorthMutex" v-model="deprInfo.orgWorthChecked" @change="comnCheckChange('orgWorth')"></el-checkbox>
                        </td>
                        <td><span>资产原值(元)</span></td>
                        <td style="text-align: right"><span v-if="deprInfo.orgWorth != null">{{deprInfo.orgWorth.toFixed(2)}}</span></td>
                        <td>
                            <el-input class="text-right" v-if="deprInfo.orgWorthChecked" :disabled="aspectInfoMap['orgWorth'] != null || deprInfo.orgWorthMutex" type="text" v-model="deprInfo.orgWorth2" @change="orgWorthChange(deprInfo)"></el-input>
                        </td>
                        <td><span></span></td>
                        <td style="text-align: right">
                            <span v-if="deprInfo.orgWorth3 != null" :class="deprInfo.orgWorth2 != deprInfo.orgWorth3? 'font-blue': ''">{{deprInfo.orgWorth3}}</span>
                        </td>
                        <td style="width: 180px;">
                            <span v-if="aspectInfoMap['orgWorth'] != null" class="font-gold">{{aspectInfoMap['orgWorth']}}</span>
                            <!--<el-tooltip class="item fr" effect="dark" placement="top" :open-delay="200">-->
                            <!--<span slot="content" style="white-space: pre-wrap" v-html="orgWorthText"></span>-->
                            <!--<span class="col-title-tooltip-wrapper"><i class="el-icon-question col-title-tooltip"></i></span>-->
                            <!--</el-tooltip>-->
                        </td>
                    </tr>
                </tbody>
                <tbody class="body" v-if="row.deprMethodCode != deprMethodNONE && row.deprMethodCode != deprMethodONCE">
                    <tr class="row" v-if="purchReceiptId == null">
                        <td style="width: 50px;text-align: center;">
                            <el-checkbox :disabled="aspectInfoMap['deprWorth'] != null || deprInfo.deprWorthMutex" v-model="deprInfo.deprWorthChecked" @change="comnCheckChange('deprWorth')"></el-checkbox>
                        </td>
                        <td><span>近期折旧(元)</span></td>
                        <td style="text-align: right"><span v-if="deprInfo.deprWorth != null">{{deprInfo.deprWorth.toFixed(2)}}</span></td>
                        <td>
                            <el-input class="text-right" v-if="deprInfo.deprWorthChecked" :disabled="aspectInfoMap['deprWorth'] != null || deprInfo.deprWorthMutex" type="text" v-model="deprInfo.deprWorth2" @change="deprWorthChange(deprInfo)"></el-input>
                        </td>
                        <td><span></span></td>
                        <td style="text-align: right"><span v-if="deprInfo.deprWorth3 != null" :class="deprInfo.deprWorth2 != deprInfo.deprWorth3? 'font-blue': ''">{{deprInfo.deprWorth3}}</span>
                        </td>
                        <td style="width: 180px;">
                            <span v-if="aspectInfoMap['deprWorth'] != null" class="font-gold">{{aspectInfoMap['deprWorth']}}</span>
                            <!--<el-tooltip class="item fr" effect="dark" placement="top" :open-delay="200">-->
                            <!--<span slot="content" style="white-space: pre-wrap" v-html="deprWorthText"></span>-->
                            <!--<span class="col-title-tooltip-wrapper"><i class="el-icon-question col-title-tooltip"></i></span>-->
                            <!--</el-tooltip>-->
                        </td>
                    </tr>
                    <tr class="row" v-if="bizVoucherType == null && purchReceiptId == null">
                        <td style="width: 50px; text-align: center;">
                            <el-checkbox :disabled="aspectInfoMap['durableLife'] != null" v-model="deprInfo.durableLifeChecked" @change="comnCheckChange('durableLife')"></el-checkbox>
                        </td>
                        <td><span>使用年限(月)</span></td>
                        <td style="text-align: right"><span>{{deprInfo.durableLife}}</span></td>
                        <td>
                            <el-input class="text-right" v-if="deprInfo.durableLifeChecked" :disabled="aspectInfoMap['durableLife'] != null" type="text" v-model="deprInfo.durableLife2" @change="durableLifeChange(deprInfo)"></el-input>
                        </td>
                        <td><span></span></td>
                        <td style="text-align: right">
                            <span v-if="deprInfo.durableLife3 != null" :class="deprInfo.durableLife2 != deprInfo.durableLife3? 'font-blue': ''">{{deprInfo.durableLife3}}</span>
                        </td>
                        <td style="width: 180px;">
                            <span v-if="aspectInfoMap['durableLife'] != null" class="font-gold">{{aspectInfoMap['durableLife']}}</span>
                            <!--<el-tooltip class="item fr" effect="dark" placement="top" :open-delay="200">-->
                            <!--<span slot="content" style="white-space: pre-wrap" v-html="durableLifeText"></span>-->
                            <!--<span class="col-title-tooltip-wrapper"><i class="el-icon-question col-title-tooltip"></i></span>-->
                            <!--</el-tooltip>-->
                        </td>
                    </tr>
                    <tr class="row" v-if="purchReceiptId == null">
                        <td style="width: 50px; text-align: center;">
                            <el-checkbox :disabled="aspectInfoMap['onsetDate'] != null" v-model="deprInfo.onsetDateChecked" @change="comnCheckChange('onsetDate')"></el-checkbox>
                        </td>
                        <td><span>起算日期</span></td>
                        <td style="text-align: right"><span>{{deprInfo.onsetDate}}</span></td>
                        <td>
                            <el-date-picker style="width: 100%" v-if="deprInfo.onsetDateChecked" :disabled="aspectInfoMap['onsetDate'] != null" v-model="deprInfo.onsetDate2" :picker-options="pickerOptions0" type="date" placeholder="选择日期" @change="disabledDateSelect"></el-date-picker>
                        </td>
                        <td><span></span></td>
                        <td style="text-align: right">
                            <span v-if="deprInfo.onsetDate3 != null" :class="deprInfo.onsetDate2 != deprInfo.onsetDate3? 'font-blue': ''">{{deprInfo.onsetDate3}}</span>
                        </td>
                        <td style="width: 180px;">
                            <span v-if="aspectInfoMap['onsetDate'] != null" class="font-gold">{{aspectInfoMap['onsetDate']}}</span>
                            <!--<el-tooltip class="item fr" effect="dark" placement="top" :open-delay="200">-->
                            <!--<span slot="content" style="white-space: pre-wrap" v-html="onsetDateText"></span>-->
                            <!--<span class="col-title-tooltip-wrapper"><i class="el-icon-question col-title-tooltip"></i></span>-->
                            <!--</el-tooltip>-->
                        </td>
                    </tr>
                    <tr class="row" v-if="bizVoucherType == null && purchReceiptId == null">
                        <td style="width: 50px;text-align: center;">
                            <el-checkbox :disabled="aspectInfoMap['rmnWorthRatio'] != null" v-model="deprInfo.rmnWorthRatioChecked" @change="comnCheckChange('rmnWorthRatio')"></el-checkbox>
                        </td>
                        <td><span>残值率(%)</span></td>
                        <td style="text-align: right"><span>{{deprInfo.rmnWorthRatio}}</span></td>
                        <td>
                            <el-input class="text-right" v-if="deprInfo.rmnWorthRatioChecked" :disabled="aspectInfoMap['rmnWorthRatio'] != null" type="text" v-model="deprInfo.rmnWorthRatio2" @change="rmnWorthRatioChange(deprInfo)"></el-input>
                        </td>
                        <td><span></span></td>
                        <td style="text-align: right">
                            <span v-if="deprInfo.rmnWorthRatio3 != null" :class="deprInfo.rmnWorthRatio2 != deprInfo.rmnWorthRatio3? 'font-blue': ''">{{deprInfo.rmnWorthRatio3}}</span>
                        </td>
                        <td style="width: 180px;">
                            <span v-if="aspectInfoMap['rmnWorthRatio'] != null" class="font-gold">{{aspectInfoMap['rmnWorthRatio']}}</span>
                            <!--<el-tooltip class="item fr" effect="dark" placement="top" :open-delay="200">-->
                            <!--<span slot="content" style="white-space: pre-wrap" v-html="rmnWorthRatioText"></span>-->
                            <!--<span class="col-title-tooltip-wrapper"><i class="el-icon-question col-title-tooltip"></i></span>-->
                            <!--</el-tooltip>-->
                        </td>
                    </tr>
                    <tr class="row">
                        <td style="width: 50px;text-align: center;">
                            <el-checkbox :disabled="aspectInfoMap['aggtDeprWorth'] != null || purchReceiptId != null" v-model="deprInfo.aggtDeprWorthChecked" @change="comnCheckChange('aggtDeprWorth')"></el-checkbox>
                        </td>
                        <td><span>累计折旧/摊销(元)</span></td>
                        <td style="text-align: right"><span v-if="deprInfo.aggtDeprWorth != null">{{deprInfo.aggtDeprWorth.toFixed(2)}}</span></td>
                        <td>
                            <el-input class="text-right" v-if="deprInfo.aggtDeprWorthChecked" :disabled="aspectInfoMap['aggtDeprWorth'] != null || purchReceiptId != null" type="text" v-model="deprInfo.aggtDeprWorth2" @change="deprWorthChange(deprInfo)"></el-input>
                        </td>
                        <td>
                            <!--<el-select v-model="deprInfo.deprMonth2" v-if="deprInfo.aggtDeprWorthChecked && deprInfo.deprMethodCode != 'NONE' && deprInfo.deprMethodCode != 'ONCE'" :disabled="aspectInfoMap['aggtDeprWorth'] != null" placeholder="请选择折旧月份">-->
                            <!--<el-option v-for="deprMonth in deprMonthList" :key="deprMonth" :label="deprMonth" :value="deprMonth"></el-option>-->
                            <!--</el-select>-->
                            <el-date-picker style="width: 100%" v-if="deprInfo.aggtDeprWorthChecked" :disabled="aspectInfoMap['aggtDeprWorth'] != null || purchReceiptId != null" format="yyyyMM" value-format="yyyyMM" type="month" :picker-options="pickerOptions2" v-model="deprInfo.deprMonthDate" placeholder="选择折旧月份" @change="changeDeprMonth"></el-date-picker>
                        </td>
                        <td style="text-align: right">
                            <span v-if="deprInfo.aggtDeprWorth3 != null" :class="deprInfo.aggtDeprWorth2 != deprInfo.aggtDeprWorth3? 'font-blue': ''">{{deprInfo.aggtDeprWorth3}}</span>
                        </td>
                        <td style="width: 180px;">
                            <span v-if="aspectInfoMap['aggtDeprWorth'] != null" class="font-gold">{{aspectInfoMap['aggtDeprWorth']}}</span>
                            <!--<el-tooltip class="item fr" effect="dark" placement="top" :open-delay="200">-->
                            <!--<span slot="content" style="white-space: pre-wrap" v-html="aggtDeprWorthText"></span>-->
                            <!--<span class="col-title-tooltip-wrapper"><i class="el-icon-question col-title-tooltip"></i></span>-->
                            <!--</el-tooltip>-->
                        </td>
                    </tr>
                    <tr class="row">
                        <td style="width: 50px;text-align: center;"></td>
                        <td><span>资产净值(元)</span></td>
                        <td style="text-align: right"><span v-if="deprInfo.netWorth != null">{{deprInfo.netWorth.toFixed(2)}}</span></td>
                        <td style="text-align: right"><!--<span v-if="deprInfo.netWorth2 != null">{{deprInfo.netWorth2.toFixed(2)}}</span>--></td>
                        <td></td>
                        <td style="text-align: right"><span v-if="deprInfo.netWorth2 != null">{{deprInfo.netWorth2.toFixed(2)}}</span></td>
                        <td style="width: 180px;"></td>
                    </tr>
                </tbody>
            </table>
            <div class="simple-form flex col-2 label" v-if="recalcFlag">
                <div class="form-group center">
                    <div class="form-label"></div>
                    <div class="form-value ">
                        <el-tooltip class="item" effect="dark" placement="top" :open-delay="200">
                            <span slot="content" style="white-space: pre-wrap" v-html="recalMonthText"></span>
                            <span class="col-title-tooltip-wrapper"><i class="el-icon-question col-title-tooltip"></i></span>
                        </el-tooltip>
                        <el-checkbox :disabled="!recalAvailable || recalAvailable && (deprMonthList.length <= 0 || deprInfo.recalFlagMutex)" v-model="deprInfo.recalFlag" @change="comnCheckChange('recalFlag')">
                            <span>重算历史</span>
                        </el-checkbox>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>起算月份</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-select v-model="deprInfo.recalMonth" clearable :disabled="deprMonthList.length <= 0 || deprInfo.recalFlagMutex" @change="recalMonthChange()">
                            <el-option v-for="recalMonth in deprMonthList" :label="recalMonth" :value="recalMonth"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="hint block" v-if="!recalAvailable && disRecalMsg != null">
                <p class="font-red">{{disRecalMsg || ''}}</p>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, Routes, MsgBox } from '../../app.vues'
    import { getMerchantBizParam } from '../asset/assetMain'

    import assetFiscalApi from '../../api/assetFiscal'
    import fiscalBizApi from '../../api/fiscalBiz'

    export default {
        name: 'swb-depr-info-update',
        desc: '折旧信息修改',
        props: {
            row: {
                type: Object,
                default: {}
            },
            bizVoucherType: {
                type: Number,
                default: null
            },
            purchReceiptId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                taxPriceText: "",
                taxRateText: "",
                orgWorthText: "",
                deprWorthText: "",
                durableLifeText: "",
                onsetDateText: "",
                rmnWorthRatioText: "",
                aggtDeprWorthText: "",
                recalMonthText: "",
                //
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                pickerOptions2: {
                    disabledDate(time) {
                        return parseInt(time.format('yyyyMM')) > parseInt((new Date()).format('yyyyMM'));
                    }
                },
                deprInfo: {
                    orgWorthChecked: false,
                    taxRateChecked: false,
                    taxPriceChecked: false,
                    onsetDateChecked: false,
                    durableLifeChecked: false,
                    rmnWorthRatioChecked: false,
                    deprWorthChecked: false,
                    aggtDeprWorthChecked: false,
                    // 互斥禁用
                    taxRateMutex: false,
                    orgWorthMutex: false,
                    taxPriceMutex: false,
                    deprWorthMutex: false,
                    recalFlagMutex: false,
                    // 仅购置验收单使用，与其他的全部互斥
                    ntxPriceMutex: false,
                },
                deprMonthList: [],
                aspectInfoMap: {},
                fiscalTaxMarkList: [],
                recalcFlag: false, // 参数控制是否可以重新
                recalAvailable: false, // 选择重算月份能不能进行重算
                disRecalMsg: null, // 不能重算的原因
                deprMethodNONE: getEnumInfoWith('assetDeprMethod', 'name', 'NONE').name,
                deprMethodONCE: getEnumInfoWith('assetDeprMethod', 'name', 'ONCE').name
            }
        },
        created: function () {
            let deprInfo = this.row || {};
            if(!Utils.isNoB(this.row) && this.row.deviceXId > 0) {
                this.deprInfo = Utils.merge({}, deprInfo);
                // 调整检查结果
                this.getAssetDeprAdjustCheckResult(this.deprInfo);
                // 获取折旧起算月份
                this.getAssetDeprMonthList(this.deprInfo);
                // 进项税率
                this.getFiscalTaxMarkList();
            }
            this.makePromptContent();
            this.disabledDateSelect();
            //
            let self = this;
            getMerchantBizParam("asset.depr.adjust.allow.history.recalc", function (result) {
                self.recalcFlag = Utils.isTrue(result);
                if(self.recalcFlag) {
                    self.recalAvailable = true;
                }
            });
            // 购置互斥处理
            if(!Utils.isNoB(this.purchReceiptId)) {
                deprInfo.ntxPriceMutex = false;
                //
                deprInfo.taxRateMutex = true;
                deprInfo.orgWorthMutex = true;
                deprInfo.taxPriceMutex = true;
                deprInfo.deprWorthMutex = true;
                deprInfo.recalFlagMutex = true;
            } else {
                deprInfo.ntxPriceMutex = true;
            }
            this.deprInfo = Utils.merge({}, deprInfo);
        },
        methods: {
            // 选择组件禁用
            disabledDateSelect: function () {
                let deprInfo = this.deprInfo;
                let onsetDate = deprInfo.onsetDate;
                if(!Utils.isNoB(deprInfo.onsetDate2)) {
                    onsetDate = deprInfo.onsetDate2;
                }
                if(!Utils.isNoB(onsetDate)) {
                    let deprMonthList = this.deprMonthList || [];
                    if(deprMonthList.length > 0) {
                        let deprMonth = deprMonthList[deprMonthList.length - 1];
                        this.pickerOptions2 = {
                            disabledDate(time) {
                                return parseInt(time.format('yyyyMM')) > parseInt((new Date()).format('yyyyMM')) || parseInt(time.format('yyyyMM')) < parseInt(deprMonth);
                            }
                        };
                    } else {
                        this.pickerOptions2 = {
                            disabledDate(time) {
                                return parseInt(time.format('yyyyMM')) > parseInt((new Date()).format('yyyyMM')) || parseInt(time.format('yyyyMM')) < parseInt((new Date(onsetDate)).format('yyyyMM'));
                            }
                        };
                    }
                }
            },
            // 调整检查结果
            getAssetDeprAdjustCheckResult: function (deprInfo) {
                let self = this;
                let theLoad = MsgBox.loading();
                assetFiscalApi.getAssetDeprAdjustCheckResult(deprInfo, function (result) {
                    theLoad.close();
                    if(result.type == "info") {
                        //
                        self.aspectInfoMap = result.data || {};
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取折旧月份列表
            getAssetDeprMonthList: function (deprInfo) {
                let self = this;
                let theLoad = MsgBox.loading();
                assetFiscalApi.getAssetDeprMonthList(deprInfo, function (result) {
                    theLoad.close();
                    if(result.type == "info") {
                        //
                        self.deprMonthList = result.data || [];
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 进项税率
            getFiscalTaxMarkList: function () {
                let self = this;
                let postData = {};
                postData.disabled = false;
                postData.type = getEnumInfoWith('taxType', "name", "JXS").value;
                let theLoad = MsgBox.loading();
                fiscalBizApi.getFiscalTaxMarkPageList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let fiscalTaxMarkList = result.data || [];
                        if(fiscalTaxMarkList.length > 0) {
                            fiscalTaxMarkList.forEach(function (item) {
                                item.rate = parseFloat(item.rate).toFixed(2)
                            })
                        }
                        self.fiscalTaxMarkList = fiscalTaxMarkList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 资产原值校验
            orgWorthChange: function (deprInfo) {
                if(!Utils.isNoB(deprInfo.orgWorth2)) {
                    if(!Utils.isMoneyStr(deprInfo.orgWorth2)) {
                        MsgBox.warning('请输入正确的金额');
                        deprInfo.orgWorth2 = null;
                    } else {
                        deprInfo.orgWorth2 = parseFloat(deprInfo.orgWorth2).toFixed(2);
                    }
                }
                this.deprInfo = Utils.merge({}, deprInfo);
            },
            // 折旧金额校验 - 累计折旧/摊销
            deprWorthChange: function (deprInfo) {
                if(!Utils.isNoB(deprInfo.deprWorth2)) {
                    if(!Utils.isMoneyStr(deprInfo.deprWorth2)) {
                        MsgBox.warning('请输入正确的金额');
                        deprInfo.deprWorth2 = null;
                    } else {
                        deprInfo.deprWorth2 = parseFloat(deprInfo.deprWorth2).toFixed(2);
                    }
                }
                this.deprInfo = Utils.merge({}, deprInfo);
            },
            // 使用年限
            durableLifeChange: function (deprInfo) {
                if(!Utils.isNaturalStr(deprInfo.durableLife2, true)) {
                    deprInfo.durableLife2 = null;
                    MsgBox.warning('必须为大于0的整数!');
                }
                this.deprInfo = Utils.merge({}, deprInfo);
            },
            // 残值率
            rmnWorthRatioChange: function (deprInfo) {
                if(Utils.isMoneyStr(deprInfo.rmnWorthRatio2) && parseFloat(deprInfo.rmnWorthRatio2) > 0) {
                    deprInfo.rmnWorthRatio2 = parseFloat(deprInfo.rmnWorthRatio2).toFixed(2);
                } else {
                    MsgBox.warning('必须为大于0的数字!');
                    deprInfo.rmnWorthRatio2 = null;
                }
                this.deprInfo = Utils.merge({}, deprInfo);
            },
            // 累计折旧、摊销（扩展）折旧月份
            changeDeprMonth: function (deprMontDate) {
                let deprInfo = this.deprInfo || {};
                //
                if(Date.isValidDate(deprMontDate)) {
                    deprInfo.deprMonth2 = parseInt(deprMontDate);
                    this.deprInfo = Utils.merge({}, deprInfo);
                }
            },
            // 单个选
            comnCheckChange: function (changeTag) {
                let deprInfo = this.deprInfo || {};
                let taxPriceChecked = deprInfo.taxPriceChecked;     // 进项税额
                let taxRateChecked = deprInfo.taxRateChecked;     // 进项税率
                let orgWorthChecked = deprInfo.orgWorthChecked;     // 资产原值
                let deprWorthChecked = deprInfo.deprWorthChecked;     // 近期折旧
                let durableLifeChecked = deprInfo.durableLifeChecked;     // 使用年限
                let onsetDateChecked = deprInfo.onsetDateChecked;     // 起算日期
                let rmnWorthRatioChecked = deprInfo.rmnWorthRatioChecked;     // 残值率
                let aggtDeprWorthChecked = deprInfo.aggtDeprWorthChecked;     // 累计折旧/摊销
                //
                if(changeTag == 'taxPrice') {// 进项税额
                    if(Utils.isTrue(taxPriceChecked)) {
                        deprInfo.taxRateChecked = false;
                        deprInfo.orgWorthChecked = false;
                        // 互斥禁用
                        deprInfo.taxRateMutex = true;
                        deprInfo.orgWorthMutex = true;
                        deprInfo.taxRate2 = null;
                        deprInfo.taxRateFlag = false;
                        deprInfo.orgWorth2 = null;
                        deprInfo.orgWorthFlag = false;
                    } else {
                        deprInfo.taxRateMutex = false;
                        deprInfo.orgWorthMutex = false;
                    }
                } else if(changeTag == 'taxRate') {
                    // 进项税率
                    if(Utils.isTrue(taxRateChecked)) {
                        deprInfo.taxPriceChecked = false;
                        deprInfo.orgWorthChecked = false;
                        // 互斥禁用
                        deprInfo.taxPriceMutex = true;
                        deprInfo.orgWorthMutex = true;
                        deprInfo.taxPrice2 = null;
                        deprInfo.taxPriceFlag = false;
                        deprInfo.orgWorth2 = null;
                        deprInfo.orgWorthFlag = false;
                    } else {
                        deprInfo.taxPriceMutex = false;
                        deprInfo.orgWorthMutex = false;
                    }
                } else if(changeTag == 'orgWorth') {
                    // 资产原值
                    if(Utils.isTrue(orgWorthChecked)) {
                        deprInfo.taxPriceChecked = false;
                        deprInfo.taxRateChecked = false;
                        // 互斥禁用
                        deprInfo.taxPriceMutex = true;
                        deprInfo.taxRateMutex = true;
                        deprInfo.taxPrice2 = null;
                        deprInfo.taxPriceFlag = false;
                        deprInfo.taxRate2 = null;
                        deprInfo.taxRateFlag = false;
                    } else {
                        deprInfo.taxPriceMutex = false;
                        deprInfo.taxRateMutex = false;
                    }
                } else if(changeTag == 'deprWorth') {
                    // 近期折旧
//                    if(Utils.isTrue(deprWorthChecked)) {
//                        deprInfo.recalFlagMutex = true;
//                        deprInfo.recalFlag = false; // 历史重算
//                        deprInfo.recalMonth = null; // 历史重算
//                    } else {
//                        deprInfo.recalFlagMutex = false;
//                    }
                } else if(changeTag == 'durableLife') {
                    // 使用年限

                } else if(changeTag == 'onsetDate') {
                    // 起算日期

                } else if(changeTag == 'rmnWorthRatio') {
                    // 残值率

                } else if(changeTag == 'aggtDeprWorth') {
                    // 累计折旧/摊销

                } else if(changeTag == 'recalFlag') {
                    // 历史重算
                    if(Utils.isTrue(deprInfo.recalFlag)) {
//                        deprInfo.deprWorthMutex = true;
//                        deprInfo.deprWorth2 = null;
//                        deprInfo.deprWorthFlag = false;
//                        deprInfo.deprWorthChecked = false;  // 近期折旧
//                        deprInfo.aggtDeprWorth2 = null;
//                        deprInfo.aggtDeprWorthFlag = false;
//                        deprInfo.netWorth2 = null;
//                        deprInfo.netWorthFlag = false;
                    } else {
//                        deprInfo.deprWorthMutex = false;
                        deprInfo.recalMonth = null;
                    }
                }
                this.deprInfo = Utils.merge({}, deprInfo);
            },
            // 重算月份折旧信息校验
            recalMonthChange: function () {
                let self = this;
                let deprInfo = this.deprInfo || {};
                let recalMonth = deprInfo.recalMonth;
                if(!Utils.isNoB(recalMonth)) {
                    let postData = {
                        assetType: deprInfo.assetType,
                        deprMonth: recalMonth, // 重算月份
                        deviceXId: deprInfo.deviceXId
                    };
                    //
                    let theLoad = MsgBox.loading();
                    assetFiscalApi.doValidateDeprMonthRecalAvailable(postData, function (result) {
                        theLoad.close();
                        if(result.type == "info") {
                            let recalAvailable = Utils.isTrue(result.data);
                            //
                            if(!recalAvailable) {
                                self.disRecalMsg = result.message;
                                deprInfo.recalFlag = false;
                            }
                            self.deprInfo = Utils.merge({}, deprInfo);
                            self.recalAvailable = recalAvailable;
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
            },
            // 试算结果
            takeTestResult: function (callbackFunc) {
                let self = this;
                let deprInfo = this.deprInfo || {};
                if(Utils.isTrue(deprInfo.recalFlag)) {
                    if(Utils.isNoB(deprInfo.recalMonth)) {
                        MsgBox.warning("请选择起算月份！");
                        return;
                    }
                }
                if(Date.isValidDate(deprInfo.onsetDate2)) {
                    deprInfo.onsetDate2 = deprInfo.onsetDate2.format("yyyy-MM-dd");
                }
                let theLoad = MsgBox.loading();
                assetFiscalApi.doAssetDeprAdjustTrialCalculation(deprInfo, function (result) {
                    theLoad.close();
                    if(result.type == "info") {
                        let resultDeprInfo = result.data || {};
                        //
                        if(!Utils.isNoB(resultDeprInfo.onsetDate2)) {
                            resultDeprInfo.onsetDate2 = new Date(resultDeprInfo.onsetDate2);
                        }
                        // 用于再次调整回显
                        resultDeprInfo.ntxPriceChecked = deprInfo.ntxPriceChecked;
                        resultDeprInfo.orgWorthChecked = deprInfo.orgWorthChecked;
                        resultDeprInfo.taxRateChecked = deprInfo.taxRateChecked;
                        resultDeprInfo.taxPriceChecked = deprInfo.taxPriceChecked;
                        resultDeprInfo.onsetDateChecked = deprInfo.onsetDateChecked;
                        resultDeprInfo.durableLifeChecked = deprInfo.durableLifeChecked;
                        resultDeprInfo.rmnWorthRatioChecked = deprInfo.rmnWorthRatioChecked;
                        resultDeprInfo.deprWorthChecked = deprInfo.deprWorthChecked;
                        resultDeprInfo.aggtDeprWorthChecked = deprInfo.aggtDeprWorthChecked;
//                        resultDeprInfo.recalFlag = deprInfo.recalFlag;
                        // 互斥禁用
                        resultDeprInfo.ntxPriceMutex = deprInfo.ntxPriceMutex;
                        resultDeprInfo.taxRateMutex = deprInfo.taxRateMutex;
                        resultDeprInfo.orgWorthMutex = deprInfo.orgWorthMutex;
                        resultDeprInfo.taxPriceMutex = deprInfo.taxPriceMutex;
                        resultDeprInfo.deprWorthMutex = deprInfo.deprWorthMutex;
                        resultDeprInfo.recalFlagMutex = deprInfo.recalFlagMutex;
                        // 需要保留两位小数的保留两位小数
                        resultDeprInfo.ntxPrice2 = Utils.isNoB(resultDeprInfo.ntxPrice2) ? null : parseFloat(resultDeprInfo.ntxPrice2).toFixed(2);
                        resultDeprInfo.taxPrice2 = Utils.isNoB(resultDeprInfo.taxPrice2) ? null : parseFloat(resultDeprInfo.taxPrice2).toFixed(2);
                        resultDeprInfo.taxRate2 = Utils.isNoB(resultDeprInfo.taxRate2) ? null : parseFloat(resultDeprInfo.taxRate2).toFixed(2);
                        resultDeprInfo.orgWorth2 = Utils.isNoB(resultDeprInfo.orgWorth2) ? null : parseFloat(resultDeprInfo.orgWorth2).toFixed(2);
                        resultDeprInfo.deprWorth2 = Utils.isNoB(resultDeprInfo.deprWorth2) ? null : parseFloat(resultDeprInfo.deprWorth2).toFixed(2);
                        resultDeprInfo.rmnWorthRatio2 = Utils.isNoB(resultDeprInfo.rmnWorthRatio2) ? null : parseFloat(resultDeprInfo.rmnWorthRatio2).toFixed(2);
                        resultDeprInfo.aggtDeprWorth2 = Utils.isNoB(resultDeprInfo.aggtDeprWorth2) ? null : parseFloat(resultDeprInfo.aggtDeprWorth2).toFixed(2);
                        resultDeprInfo.onsetDate2 = Utils.isNoB(resultDeprInfo.onsetDate2) ? null : resultDeprInfo.onsetDate2.format("yyyy-MM-dd");
                        // 试算结果
                        resultDeprInfo.ntxPrice3 = resultDeprInfo.ntxPrice2;
                        resultDeprInfo.taxPrice3 = resultDeprInfo.taxPrice2;
                        resultDeprInfo.taxRate3 = resultDeprInfo.taxRate2;
                        resultDeprInfo.orgWorth3 = resultDeprInfo.orgWorth2;
                        resultDeprInfo.deprWorth3 = resultDeprInfo.deprWorth2;
                        resultDeprInfo.durableLife3 = resultDeprInfo.durableLife2;
                        resultDeprInfo.onsetDate3 = resultDeprInfo.onsetDate2;
                        resultDeprInfo.rmnWorthRatio3 = resultDeprInfo.rmnWorthRatio2;
                        resultDeprInfo.aggtDeprWorth3 = resultDeprInfo.aggtDeprWorth2;
                        self.deprInfo = Utils.merge({}, resultDeprInfo);
                        if(typeof callbackFunc == 'function') {
                            callbackFunc(resultDeprInfo);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult() {
                //
                let deprInfo = this.deprInfo;
                let result = {};
                if(Utils.isTrue(deprInfo.recalFlag) && !Utils.isTrue(this.recalAvailable)) {
                    result.type = "warn";
                    result.message = Utils.isNoB(this.disRecalMsg) ? "有折旧已经计提财务，不能进行重算！" : this.disRecalMsg;
                    return result;
                } else {
                    deprInfo.recalMonth = null;
                }
                //
                let ntxPriceChecked = deprInfo.ntxPriceChecked;     // 未税价
                let taxPriceChecked = deprInfo.taxPriceChecked;     // 进项税额
                let taxRateChecked = deprInfo.taxRateChecked;     // 进项税率
                let orgWorthChecked = deprInfo.orgWorthChecked;     // 资产原值
                let deprWorthChecked = deprInfo.deprWorthChecked;     // 近期折旧
                let durableLifeChecked = deprInfo.durableLifeChecked;     // 使用年限
                let onsetDateChecked = deprInfo.onsetDateChecked;     // 起算日期
                let rmnWorthRatioChecked = deprInfo.rmnWorthRatioChecked;     // 残值率
                let aggtDeprWorthChecked = deprInfo.aggtDeprWorthChecked;     // 累计折旧/摊销
                //
                if(Utils.isTrue(deprInfo.recalFlag)) {
                    if(Utils.isNoB(deprInfo.recalMonth)) {
                        result.type = "warn";
                        result.message = "请选择起算月份！";
                        return result;
                    }
                } else {
                    if(!ntxPriceChecked && !taxPriceChecked && !taxRateChecked && !orgWorthChecked && !deprWorthChecked && !durableLifeChecked &&   //
                        !onsetDateChecked && !rmnWorthRatioChecked && !aggtDeprWorthChecked) {
                        result.type = "warn";
                        result.message = "请勾选要调整信息的项！";
                        return result;
                    }
                }
                if(ntxPriceChecked && Utils.isNoB(deprInfo.ntxPrice2)) {
                    result.type = "warn";
                    result.message = "请输入修改后的未税价！";
                    return result;
                }
                //
                if(taxPriceChecked && Utils.isNoB(deprInfo.taxPrice2)) {
                    result.type = "warn";
                    result.message = "请输入修改后的进项税额！";
                    return result;
                }
                if(taxRateChecked && Utils.isNoB(deprInfo.taxRate2)) {
                    result.type = "warn";
                    result.message = "请输入修改后的进项税率！";
                    return result;
                }
                if(orgWorthChecked && Utils.isNoB(deprInfo.orgWorth2)) {
                    result.type = "warn";
                    result.message = "请输入修改后的资产原值！";
                    return result;
                }
                if(deprWorthChecked && Utils.isNoB(deprInfo.deprWorth2)) {
                    result.type = "warn";
                    result.message = "请输入修改后的近期折旧金额！";
                    return result;
                }
                if(durableLifeChecked && Utils.isNoB(deprInfo.durableLife2)) {
                    result.type = "warn";
                    result.message = "请输入修改后的使用年限！";
                    return result;
                }
                if(onsetDateChecked) {
                    if(Utils.isNoB(deprInfo.onsetDate2)) {
                        result.type = "warn";
                        result.message = "请输入修改后的起算日期！";
                        return result;
                    } else {
                        deprInfo.onsetDate2 = new Date(deprInfo.onsetDate2).format("yyyy-MM-dd");
                    }
                }
                if(rmnWorthRatioChecked && Utils.isNoB(deprInfo.rmnWorthRatio2)) {
                    result.type = "warn";
                    result.message = "请输入修改后的残值率！";
                    return result;
                }
                if(aggtDeprWorthChecked) {
                    if(Utils.isNoB(deprInfo.aggtDeprWorth2)) {
                        result.type = "warn";
                        result.message = "请输入修改后的累计折旧/摊销！";
                        return result;
                    }
                    if(deprInfo.deprMethodCode != 'NONE' && deprInfo.deprMethodCode != 'ONCE' && Utils.isNoB(deprInfo.deprMonth2)) {
                        result.type = "warn";
                        result.message = "请选择修改后的累计折旧/摊销的（扩展）折旧月份！";
                        return result;
                    }
                }
                result.type = "info";
                result.data = deprInfo;
                return result;
            },
            //
            makePromptContent: function () {
                this.taxPriceText = "进项税额调整：</br>" +
                    "（1）选择进项税额调整不可选择的调整项：进项税率、原值、当期折旧、累计折旧；</br>" +
                    "（2）起算日期仅往当前之后的日期选择；</br>" +
                    "（3）使用年限可调增、调减；</br>" +
                    "（4）当月折旧不可修改，累计折旧不可修改，残值率可修改，修改后，折旧按修改的残值率计算；</br>" +
                    "（5）历史重算不可选择；</br>" +
                    "（6）已计提、导入资产不允许进项税调整；</br>" +
                    "（7）购置入账后未计提可以调整；</br>";
                this.taxRateText = "进项税率调整：</br>" +
                    "（1）选择进项税率调整不可选择的调整项：进项税额、原值、当期折旧、累计折旧；</br>" +
                    "（2）起算日期仅往当前之后的日期选择；</br>" +
                    "（3）使用年限可调增、调减；</br>" +
                    "（4）当月折旧不可修改，累计折旧不可修改，残值率可修改，修改后，折旧按修改的残值率计算；</br>" +
                    "（5）历史重算不可选择；</br>" +
                    "（6）已计提、导入资产不允许进项税调整；</br>" +
                    "（7）购置入账后未计提可以调整；</br>";
                this.orgWorthText = "资产原值调整：</br>" +
                    "（1）调整原值，互斥项：进项税率、进项税额；</br>" +
                    "（2）不建议调整：折旧年限、残值率、当期折旧、累计折旧；</br>" +
                    "（3）已入账计提过的资产，不允许直接修改原值；</br>" +
                    "（4）导入未计提过的资产，没有含税价，允许直接修改原值；</br>" +
                    "（5）购置未计提过的资产，可以通过调整税率、税额修改原值；</br>" +
                    "（6）导入已计提过的资产，没有含税价，可以直接修改原值，以导入时间开始，必须历史重算；</br>" +
                    "（7）购置已计提过的资产，不支持修改原值；</br>";
                this.deprWorthText = "近期折旧调整</br>" +
                    "（1）选择当月当期调整互斥的调整项、残值率、累计折旧；</br>" +
                    "（2）未计提的资产，不支持；</br>" +
                    "（3）计提过的资产，可调整，不支持重算；";
                this.durableLifeText = "使用年限调整：</br>" +
                    "（1）导入、购置资产尚未计提，可以调整，历史重算不可选；</br>" +
                    "（2）计提过的资产，增加折旧年限，历史重算不可选；</br>" +
                    "（3）计提过的资产，调整年限小于总折旧年限，历史重选默认选中，不可修改；</br>" +
                    "（4）已计提资产选择折旧年限调整，可以选择的调整项：（原值、进项税率、进项税码）互斥、起算日期、残值率、当月折旧、累计折旧；";
                this.onsetDateText = "起算日期调整：</br>" +
                    "（1）导入、购置资产尚未计提，起算期仅可调整当前之后的时间，无需从算历史；</br>" +
                    "（2）计提过的资产，若调整起算日期早于原起算日期一个月，重算历史默认选中，不可修改；</br>" +
                    "（3）计提过的资产，若调整起算日期晚于原起算日期后一个月，重算历史默认选中，不可修改；</br>" +
                    "（4）计提过的资产，若调整起算日期早于最后一个月的日期，重算历史默认选中，不可修改；";
                this.rmnWorthRatioText = "残值率调整：</br>" +
                    "（1）选择残值率互斥的调整项、当月折旧、累计折旧；</br>" +
                    "（2）未计提的资产，可以调整残值率；</br>" +
                    "（3）计提过的资产，调整残值率，默认选中历史重算，不可修改；";
                this.aggtDeprWorthText = "累计折旧/摊销</br>" +
                    "（1）选择累计折旧整互斥的调整项、残值率、当月折旧；";
                /* "（2）未计提的资产，不支持；";
                 "（3）计提过的资产，可调整，仅计入当月，不支持重算；";*/
                this.recalMonthText = "历史重算调整：</br>" +
                    "（1）删除原值折旧历史，产生新历史；</br>" +
                    "（2）对于折旧的历史也会删除；</br>" +
                    "（3）未计提，历史重算无效；</br>";
            }
        }
    }
</script>

<style>
    .simple-tbl > .head > .row > th {
        background-color: #c5dbff;
        border: 1px solid #bbd1f5;
        padding: 0 4px;
    }
</style>



// WEBPACK FOOTER //
// src/compo/assetFiscal/DeprInfoUpdate.vue